import InstitutionForm from './institution-form';

export default InstitutionForm;
